<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="confirmationData"
                    :columns="columns"
                    :sort-options="{
                      enabled: true,
                      initialSortBy: {field: 'id', type: 'desc'}
                    }"
                    @on-sort-change="onSortChange"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'btn'">
                      <b-button pill size="sm" v-b-modal.modal-donasi @click="setModalConfirmation(props.row)">Validasi Pembayaran</b-button>
                    </div>
                    <div v-else-if="props.column.field == 'proof'">
                      <a :href="props.row.proof" target="_blank"><b-button pill size="sm">Lihat Bukti Pembayaran</b-button></a>
                    </div>
                    <div v-else-if="props.column.field == 'order_total'">
                      {{ props.row.order_total | formatCurrency }}
                    </div>
                    <div v-else-if="props.column.field == 'current_payment'">
                      {{ props.row.current_payment | formatCurrency }}
                    </div>
                    <div v-else-if="props.column.field == 'approve'">
                      <b-badge v-if="props.row.approve === ''" variant="warning">Belum di Validasi</b-badge>
                      <b-badge v-else-if="props.row.approve.toLowerCase() === 'valid' && props.row.order_total - props.row.total_previous_payment - props.row.current_payment <= 0" variant="success">LUNAS</b-badge>
                      <b-badge v-else-if="props.row.approve.toLowerCase() === 'valid'" variant="success">VALID</b-badge>
                      <b-badge v-else variant="danger">TIDAK VALID</b-badge>
                    </div>
                    <div v-else-if="props.column.field == 'insufficient_payment'">
                      {{ (props.row.order_total - props.row.total_previous_payment - props.row.current_payment) | formatCurrency }}
                    </div>
                    <div v-else-if="props.column.field == 'log'">
                      <div class="p-1">
                        <b-button pill size="sm" @click="getLog(props.row.id)">Log</b-button>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <b-modal id="modal-donasi" title="Konfirmasi" button-size="sm">
                <label>Jumlah Transfer:</label>
                <b-form-input v-model="payloadConfirmation.current_payment" type="number" placeholder="Masukkan Jumlah Transfer"></b-form-input>
                <label>Status:</label>
                <b-form-select v-model="payloadConfirmation.approve" :options="validationOption"></b-form-select>
                <template #modal-footer="{ cancel, ok }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                  <b-button variant="primary" size="sm" @click="validateConfirmation">
                    Update dan Kirim Email
                  </b-button>
                </template>
              </b-modal>
              <b-modal id="modal-bukti-tf" title="Bukti Transfer" button-size="sm">
                <div>
                  <p style="color: #000;">
                    <span>Link: </span> <a :href="activeConfirmation.proof">{{ activeConfirmation.proof }}</a><br><br>
                    <img :src="activeConfirmation.proof" style="max-width: 100%"/>
                  </p>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                </template>
              </b-modal>
              <b-modal id="modal-log" title="Detail Log" size="xl" button-size="sm">
                <div>
                  <b-table striped hover :items="logHistory">
                    <template #cell(id)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                </template>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
import debounce from "debounce";
export default {
  name: "konfirmasi",
  page: {
    title: "Konfirmasi",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchConfirmationData()
  },
  filters: {
    formatCurrency(number) {
      return number.toLocaleString() + ',-'
    }
  },
  data() {
    return {
      title: "Konfirmasi",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Konfirmasi",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        search: '',
      },
      payloadConfirmation: {
        current_payment: 0,
        approve: 'VALID'
      },
      confirmationData: [],
      columns: [
        { field: "id", label: "Urutan"},
        { field: "created_date", label: "Tanggal Konfirmasi"},
        { field: "name", label: "Nama"},
        { field: "email", label: "Email", sortable: false},
        { field: "order_id", label: "Kode Pemesanan", sortable: false},
        { field: "hp", label: "No. HP", sortable: false},
        { field: "approve", label: "Status", sortable: false},
        { field: "proof", label: "Bukti Pembayaran", sortable: false},
        { field: "order_total", label: "Total Order", sortable: false},
        { field: "current_payment", label: "Pembayaran Saat Ini", sortable: false },
        { field: "insufficient_payment", label: "Kekurangan Pembayaran", sortable: false },
        { field: "log", label: "Log", sortable: false },
        { field: "btn", label: "Action", sortable: false },
      ],
      exportLoading: false,
      validationOption: [
        { value: 'VALID', text: 'VALID' },
        { value: 'INVALID', text: 'INVALID' },
      ],
      activeConfirmation: {},
      logHistory: []
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchConfirmationData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallConfirmationData(params)
    },
    httpCallConfirmationData(params) {
      axios.get("/api/confirmation?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.proof
            this.confirmationData = data
            this.isFetched = true
          });
    },
    setModalConfirmation(confirmation) {
      this.activeConfirmation = confirmation
      this.payloadConfirmation.current_payment = confirmation.current_payment
      if (confirmation.approve === '') {
        this.payloadConfirmation.approve = 'VALID'
      } else {
        this.payloadConfirmation.approve = confirmation.approve.toUpperCase()
      }
    },
    setModalProof(confirmation) {
      this.activeConfirmation = confirmation
    },
    validateConfirmation() {
      axios.put("/api/confirmation/validate/"+this.activeConfirmation.id, this.payloadConfirmation).then(resp => {
        const { data } = resp.data
        Swal.fire('Sukses')
        this.$bvModal.hide('modal-donasi')
        this.$router.go()
      });
    },
    getLog(id) {
      axios.get("/api/audit/confirmation/"+id).then(resp => {
        const { data } = resp.data
        this.logHistory = data
        this.$bvModal.show('modal-log')
      });
    },
    onSortChange(params) {
      let sortBy = params[0].field
      if (params[0].type === 'desc') {
        sortBy = "-"+sortBy
      }
      this.getArguments.sort = sortBy
      let args = queryString.stringify(this.getArguments)
      this.httpCallConfirmationData(args)
    },
  },
  watch: {
    searchText: {
      handler: debounce(function(value){
        this.currentPage = 1
        let params = queryString.stringify({
          limit: this.perPage,
          page: this.currentPage,
          search: value,
          sort: '-id',
        })
        this.httpCallConfirmationData(params)
      }, 500)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          search: this.searchText,
          sort: '-id',
        })
        this.httpCallConfirmationData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          search: this.searchText,
          sort: '-id',
        })
        this.httpCallConfirmationData(params)
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>